import { useLanguage } from "@/i18n";

const Diamond = () => (
  <svg viewBox="0 0 10 10" className="w-2 h-2 mx-8 shrink-0" aria-hidden="true">
    <rect x="1.5" y="1.5" width="7" height="7" transform="rotate(45 5 5)" fill="#D4AF37" opacity="0.8" />
  </svg>
);

export const EditorialMarquee = () => {
  const { t } = useLanguage();
  const items = [...t.marquee, ...t.marquee];

  return (
    <div className="relative bg-midnight border-y border-hairline/70 py-6 overflow-hidden" data-testid="editorial-marquee">
      <div className="marquee-track flex whitespace-nowrap w-max">
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-xl sm:text-2xl text-ivory/60">{item}</span>
            <Diamond />
          </span>
        ))}
      </div>
    </div>
  );
};
